/**
 * @file CheckRow.tsx
 * @description Флажок-строка настроек вида сайта (phase19.16 Р1): подпись
 * рядом с флажком, вся строка нажимается, высота от 48 (касание).
 */

import type { ReactNode } from "react";

import { Checkbox } from "../ui/checkbox";

interface Props {
  checked: boolean;
  onChange: (value: boolean) => void;
  children: ReactNode;
  disabled?: boolean;
}

export function CheckRow({ checked, onChange, children, disabled = false }: Props) {
  return (
    <label className="flex min-h-12 cursor-pointer items-center gap-3 has-[:disabled]:cursor-not-allowed">
      <Checkbox checked={checked} disabled={disabled} onCheckedChange={(v) => onChange(v === true)} />
      <span className="type-body text-on-surface">{children}</span>
    </label>
  );
}
